export const EXCLUDED_PHONE_COUNTRIES = ['il'];

const EXCLUDED_COUNTRY_CODES = new Set(['IL']);

export const isAllowedCountryCode = (countryCode?: string | null) => {
	if (!countryCode) {
		return true;
	}

	return !EXCLUDED_COUNTRY_CODES.has(countryCode.toUpperCase());
};
